import Api from '../Api';

import { url } from './config';
import { SupplierService } from './types';

const api = new Api<SupplierService>(url);

export default api;
